module.exports = __webpack_public_path__ + "img/Standardwordverification.475c8f06.svg";